import { bytesToSize } from "@/lib/helpers";
import {
  Container,
  DocumentIcon,
  Mp3Icon,
  Description,
  Title,
  Size,
  Label,
  LabelAndDescription,
  Inner,
} from "./styles";

type Props = {
  _id?: string;
  name?: string;
  description?: string;
  asset?: Record<string, any>;
  category?: string;
  quarter?: string;
  year?: string;
};

const DocumentCard: React.FC<Props> = (props) => {
  const href = props?.asset?.url || "";
  const { _id, name, description, category, quarter, year } = props;
  const size = props?.asset?.size;
  const extension = href.substring(href.length - 3, href.length);

  return (
    <Container href={href} target="_blank" rel="noreferrer">
      <Inner>
        {extension === "pdf" ? <DocumentIcon /> : <Mp3Icon />}
        {name && <Title>{name}</Title>}
        {(quarter || year || category || description) && (
          <LabelAndDescription>
            {quarter && <Label>{quarter}</Label>}
            {year && <Label>{year}</Label>}
            {category && <Label>{category}</Label>}
            {description && <Description>{description}</Description>}
          </LabelAndDescription>
        )}
        {size && <Size>{bytesToSize(size).toLowerCase()}</Size>}
      </Inner>
    </Container>
  );
};

export default DocumentCard;
